/* Background slideshow images for the E3 Summit login screen — the same
   before/after construction composites, field shots, and team photos we use on
   Facility Navigator. Each entry is a path under client/public/login-slides/.
   The login page cross-fades through them behind the sign-in card; an EMPTY list
   falls back to the plain background. Order IS the rotation order — deliberately
   interleaved so results (before/after pairs) alternate with the people doing the
   work. Slides mount progressively (current + next), so a long list doesn't
   front-load the page. These are PUBLIC (shown pre-login) — no customer names or
   addresses in frame. */
const LOGIN_SLIDES = [
  '/login-slides/site1.jpg',   // Colmesneil before/after
  '/login-slides/build2.jpg',  // Carrizo Springs crane lift
  '/login-slides/team3.jpg',   // volunteer crew with gift boxes
  '/login-slides/site2.jpg',   // Fairfield gym before/after
  '/login-slides/build4.jpg',  // Edcouch rooftop tech
  '/login-slides/build6.jpg',  // Fairfield unit lift
  '/login-slides/site3.jpg',   // GWH before/after
  '/login-slides/build10.jpg', // Highland Park mechanical room
  '/login-slides/team8.jpg',   // Don teaching
  '/login-slides/site4.jpg',   // Highland Park before/after
  '/login-slides/build8.jpg',  // Ferris solar array
  '/login-slides/build14.jpg', // Ricardo crane + unit
  '/login-slides/site5.jpg',   // Rio Hondo exterior before/after
  '/login-slides/team5.jpg',   // volunteer fist bump
  '/login-slides/build18.jpg', // Rio Hondo pump room
  '/login-slides/site6.jpg',   // Royal before/after
  '/login-slides/build1.jpg',  // PNG stadium light install
  '/login-slides/build20.jpg', // Trinity roof walkthrough
  '/login-slides/site7.jpg',   // Bryan before/after
  '/login-slides/team2.jpg',   // volunteer packing
  '/login-slides/build9.jpg',  // Glen Rose chiller lift
  '/login-slides/site8.jpg',   // Fairfield exterior before/after
  '/login-slides/build16.jpg', // Rio Hondo unit set
  '/login-slides/team6.jpg',   // supply packing line
  '/login-slides/site9.jpg',   // Keene before/after
  '/login-slides/build3.jpg',  // Edcouch crane rooftop
  '/login-slides/build11.jpg', // Kennedale rooftop units
  '/login-slides/site10.jpg',  // Lufkin before/after
  '/login-slides/team4.jpg',   // volunteer cheer
  '/login-slides/build12.jpg', // Lamesa High School
  '/login-slides/site11.jpg',  // Port Neches-Groves HS before/after
  '/login-slides/build5.jpg',  // Edcouch piping crew
  '/login-slides/build17.jpg', // Rio Hondo crane basket
  '/login-slides/site12.jpg',  // PNG football before/after
  '/login-slides/team1.jpg',   // office event
  '/login-slides/build7.jpg',  // Fairfield copper work
  '/login-slides/site13.jpg',  // PNG Groves campus before/after
  '/login-slides/build13.jpg', // Pflugerville Copperfield delivery
  '/login-slides/team7.jpg',   // Carrizo Springs classroom
  '/login-slides/site14.jpg',  // Rio Hondo gym lighting retrofit before/after
  '/login-slides/build15.jpg', // Ricardo crane wide
  '/login-slides/site15.jpg',  // Somerset before/after
  '/login-slides/build19.jpg', // Timpson aerial
  '/login-slides/site16.jpg',  // Trinity before/after
];

export default LOGIN_SLIDES;
